import { handleActions } from 'redux-actions'
import * as actions from '../actions/settings'

export default handleActions({
  [actions.settings_set]: (state, action) => {
    let {key, value} = action.payload

    if (state[key] === value) return state

    return {
      ...state,
      [key]: value
    }
  }
}, {})


// WEBPACK FOOTER //
// ./src/reducers/settings.js